// Lib
import React from "react"
import ReactDOM from "react-dom/client" // แทน 'react-dom' เดิม
import { Provider as ReduxProvider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { QueryClientProvider, QueryClient } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { CollapseProvider } from "context/CollapseContext"
import { AuthProvider } from "context/JWTContext"

import { store } from "stores"
import reportWebVitals from "reportWebVitals"
import App from "App"

import "./locales/i18n"

const container = document.getElementById("root")
const root = ReactDOM.createRoot(container)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false
    }
  }
})
root.render(
  <AuthProvider>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <QueryClientProvider client={queryClient}>
          <CollapseProvider>
            <BrowserRouter>
              <App />
              <ReactQueryDevtools initialIsOpen={false} />
            </BrowserRouter>
          </CollapseProvider>
        </QueryClientProvider>
      </ReduxProvider>
    </HelmetProvider>
  </AuthProvider>
)

// เรียกฟังก์ชันวัด performance
reportWebVitals()
